import Axios from "axios";
import {
  SET_EXCHANGE_RATE_LIST,
  UNSET_EXCHANGE_RATE_LIST,
  SET_LATEST_EXCHANGE_RATE_LIST,
  UNSET_LATEST_EXCHANGE_RATE_LIST,
} from "@/store/mutation-types";
import { saveUpdateExchangeRate, getExchangeRateList, getLatestExchangeRateList } from "@/store/api";

const state = {
  exchangeRateList: [],
  latestExchangeRateList: [],
};

const getters = {
  getExchangeRateList(state) {
    return state.exchangeRateList;
  },
  getLatestExchangeRateList(state) {
    return state.latestExchangeRateList;
  },
};

const mutations = {
  [SET_EXCHANGE_RATE_LIST](state, data) {
    state.exchangeRateList = data;
  },
  [UNSET_EXCHANGE_RATE_LIST](state) {
    state.exchangeRateList = [];
  },
  [SET_LATEST_EXCHANGE_RATE_LIST](state, data) {
    state.latestExchangeRateList = data;
  },
  [UNSET_LATEST_EXCHANGE_RATE_LIST](state) {
    state.latestExchangeRateList = [];
  },
};

const actions = {
  saveUpdateExchangeRate({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateExchangeRate, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getExchangeRateList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getExchangeRateList, data)
        .then(function (response) {
          commit("SET_EXCHANGE_RATE_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_EXCHANGE_RATE_LIST");
          reject(error);
        });
    });
  },
  getLatestExchangeRateList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getLatestExchangeRateList, data)
        .then(function (response) {
          commit("SET_LATEST_EXCHANGE_RATE_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_LATEST_EXCHANGE_RATE_LIST");
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

